import { TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import { isEmpty } from 'lodash';
import { observer, inject } from 'mobx-react';
import * as React from 'react';

import { ThTd } from 'components/Filter/ThTd';

import { t } from 'utils';

import { Race as RaceStore } from 'stores';

import loadService from '../../../services/load';

import { Filter } from './Filters';

type Props = {
  racesStore: RaceStore;
};

type State = {
  selectedFilter: nil | string;
  anchorEl: nil | Element;
};

const POPPER_RELATIVE_Y_POSITION = -12;
const POPPER_RELATIVE_X_POSITION = 0;

const COLUMNS = ['name', 'approve_status', 'id', 'sport_id', 'race_date', 'race_location', 'organizer.email', 'updated_at'];

@inject('racesStore')
@observer
class THead extends React.Component<Props, State> {
  state: State = {
    selectedFilter: null,
    anchorEl: null,
  };

  static defaultProps = {
    racesStore: null as any,
  };

  handleShowFilter = (e: nil | React.SyntheticEvent = null, selectedFilter: nil | string = null) => {
    this.setState({
      selectedFilter,
      anchorEl: e ? e.currentTarget : null,
    });
  };

  onModalClose = () => this.handleShowFilter();

  applyFilter = (...filters: Array<FiltersType>) => {
    const hideFilter = () => this.handleShowFilter();
    loadService.applySearch(hideFilter, ...filters);
  };

  clearFilters = () => {
    const { racesStore } = this.props;
    const searchData = racesStore.searchDataModel.search;

    if (isEmpty(searchData)) {
      return null;
    }

    const clear = () => {
      loadService.clearFilters();
    };

    return (
      <li onClick={clear} className='reset-filters'>
        {t.staticAsString('races.filters.resetAll')}
      </li>
    );
  };

  updateSearchHandlers = (
    handlers: {
      [K in string]: string;
    },
  ) => {
    const { racesStore } = this.props;
    racesStore.updateSearchHandlers(handlers);
  };

  _renderThLabels = (): React.ReactNode => {
    const { racesStore } = this.props;
    const searchData = racesStore.searchDataModel.search;

    return COLUMNS.map((param) => {
      // $FlowFixMe
      return (
        <ThTd
          key={param}
          name={param}
          values={searchData}
          className='filter-item'
          label={t.staticAsString(`races.list.table.${param}` as TranslationLockedKeys)}
          value={searchData[param] || ''}
          onFilterShow={this.handleShowFilter}
          disabled={!Filter.types.includes(param)}
        />
      );
    });
  };

  _renderFilterPopover = (): React.ReactNode => {
    const { racesStore } = this.props;
    const { selectedFilter, anchorEl } = this.state;

    return (
      <Popover
        className='material-popover'
        classes={{ paper: 'popover-paper' }}
        anchorEl={anchorEl}
        open={!!this.state.selectedFilter}
        onClose={this.onModalClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: POPPER_RELATIVE_Y_POSITION,
          horizontal: POPPER_RELATIVE_X_POSITION,
        }}
      >
        <Paper className='main-layout'>
          {selectedFilter && (
            <Filter
              name={selectedFilter}
              value={racesStore.searchDataModel.search[selectedFilter]}
              values={racesStore.searchDataModel.search}
              label={t.staticAsString(`races.filters.${selectedFilter}` as TranslationLockedKeys)}
              applyFilter={this.applyFilter}
              updateSearchHandlers={this.updateSearchHandlers}
            />
          )}
        </Paper>
      </Popover>
    );
  };

  render() {
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>{this._renderThLabels()}</TableRow>
        </TableHead>
        {this._renderFilterPopover()}
      </React.Fragment>
    );
  }
}

export { THead };
